import { render, staticRenderFns } from "./WebsiteDoctorModal.vue?vue&type=template&id=759b9b11&"
import script from "./WebsiteDoctorModal.vue?vue&type=script&lang=js&"
export * from "./WebsiteDoctorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports